import {
  signInWithRedirect,
  signInWithPopup,
  OAuthProvider,
} from 'firebase/auth';
import { createUser } from './helpers';
import { FirebaseProviderAuthenticationError } from './errors';

export default function signInWithMicrosoft(auth, options = {}) {
  const scopes = options.scopes || [];
  const redirect = options.redirect || false;
  const provider = new OAuthProvider('microsoft.com');

  scopes.forEach(scope => {
    provider.addScope(scope);
  });

  provider.setCustomParameters({
    tenant: 'common',
    prompt: 'select_account',
  });

  return new Promise((resolve, reject) => {
    if (redirect) {
      try {
        signInWithRedirect(auth, provider);
        resolve();
      } catch (error) {
        reject(new FirebaseProviderAuthenticationError(error));
      }
    } else {
      signInWithPopup(auth, provider)
        .then(result => {
          resolve({ user: createUser(result.user) });
        })
        .catch(error => {
          reject(new FirebaseProviderAuthenticationError(error));
        });
    }
  });
}
